<template>
  <v-card elevation="0">
    <v-card-text>
      <v-alert color="#C51162" dark icon="mdi-alert-octagon" border="right">
        404 - Página não encontrada
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "notFound",
  data() {
    return {
      content: "404 - Página não encontrada!",
    };
  },
};
</script>
